import React from 'react';
import PropTypes from 'prop-types';
import FormattedLink from '@stubhub/react-formatted-link';
import Accordion from '@stubhub/react-accordion';

/**
 * a list of items, support mutil depth
 */
class NavMenuOptionList extends React.Component {

  handleDocumentClick = (e) => {
    // This function is attached to the document object which cannot be replicated in unit tests
    /* istanbul ignore next */
    if (this.rootNode.parentNode.parentNode.parentNode && !this.rootNode.parentNode.parentNode.parentNode.contains(e.target)) {
      // User clicked outside of this component
      if (this.props.onClickOutside) {
        this.props.onClickOutside.call(this);
      }
    }
  }

  componentDidMount() {
    // We only need to attach listener for the topmost instance
    if (!this.props.nested && document) {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('mouseout', this.handleDocumentClick);
    }
  }

  componentWillUnmount() {
    if (!this.props.nested && document) {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('mouseout', this.handleDocumentClick);
    }
  }

  render() {
    let {items, onOptionClick} = this.props;
    let accordionItems = items.map((item) => {
      let className = `mh__nav-menu-option option__${item.id}`;
      // Override heading element from being wrapped with <a> tag
      if (item.id === 'have-questions') {
        item.type = 'string';
      }
      return {
        id: item.id,
        head: item.type === 'link' ? (
          item.noFormat ?
            (<a className={className} href={item.href} data-item-id={item.id} onClick={onOptionClick}>{item.label}</a>)
            :
            (
              <FormattedLink className={className} href={item.href} data-item-id={item.id} onClick={onOptionClick}>
                {item.label}
              </FormattedLink>
            )
        ) : (
          <div id={item.id} className={className} data-item-id={item.id}>
            {item.label}
          </div>
        ),
        body: item.items ? (
          <div className="mh__nav-menu__sub-options">
            <NavMenuOptionList items={item.items} onOptionClick={onOptionClick} nested={true}/>
          </div>
        ) : null
      };
    });

    return <div ref={(node) => this.rootNode = node}><Accordion items={accordionItems}/></div>;
  }
}

NavMenuOptionList.propTypes = {
  items: PropTypes.array.isRequired,
  onOptionClick: PropTypes.func,
  onClickOutside: PropTypes.func,

  // Indicates if this component is recursively nested
  isNested: PropTypes.bool
};

NavMenuOptionList.defaultProps = {
  isNested: false
};

export default NavMenuOptionList;
